import * as React from "react";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {Formik} from "formik";
import {apAppLink} from "@web2/ap-routes";
import {Button} from "@web2/button";
import {getFormikFieldProps, IFormikSubmitFn} from "@web2/formik_utils";
import {Input} from "@web2/input";

import {mb_lg, tac} from "../../app/styles/helpers";
import {resetPassword} from "../actions/reset_password";
import {authBoxHolder, AuthLogo} from "./LoginForm";

const initialValues = {
    email: ""
};

export const ResetPasswordForm = () => {
    const dispatch = useDispatch();

    const onSubmit: IFormikSubmitFn<typeof initialValues> = async (formData, formikHelpers) => {
        if (formData.email) {
            await dispatch(resetPassword(formData.email));
        }

        formikHelpers.setSubmitting(false);
    };

    return (
        <div css={authBoxHolder}>
            <AuthLogo />

            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                {(formikProps) => (
                    <form onSubmit={formikProps.handleSubmit}>
                        <p css={[tac]}>Wprowadź adres e-mail podany podczas rejestracji, na który zostanie wysłany link do zmiany hasła.</p>

                        <Input {...getFormikFieldProps(formikProps, "email")} type="email" placeholder="Email" autoFocus required errorOnBottom />

                        <div css={[tac, mb_lg]}>
                            <Button type="submit" size="lg" variant="primary" disabled={formikProps.isSubmitting}>
                                Resetuj hasło
                            </Button>
                        </div>

                        <div css={[tac]}>
                            <Link to={apAppLink.login()}>Przejdź do strony logowania</Link>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};
